import { render, staticRenderFns } from "./MenuItemResults.vue?vue&type=template&id=57751566"
import script from "./MenuItemResults.vue?vue&type=script&lang=ts"
export * from "./MenuItemResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports